
export function planType(observations) {

  if (observations.includes("CO001")) {
    return ["VG"];
  }
  if (observations.includes("CO002")) {
    return ["AP"];
  }
  if (observations.includes("CO101")) {
    return ["VG"];
  }
  if (observations.includes("CO102")) {
    return ["AP"];
  }
  if (observations.includes("CO201")) {
    return ["VG"];
  }
  if (observations.includes("CO202")) {
    return ["AP"];
  }
  if (observations.includes("CO301")) {
    return ["VG"];
  }
  if (observations.includes("CO302")) {
    return ["AP"];
  }

  return [];
}

export function procedimiento(observations){
  if (observations.includes("CO001") || observations.includes("CO002")) {
    return "INCLUSION";
  }
  if (observations.includes("CO101") || observations.includes("CO102")) {
    return "AUMENTO";
  }
  if (observations.includes("CO201") || observations.includes("CO202")) {
    return "ACTUALIZACION";
  }
  if (observations.includes("CO301") || observations.includes("CO302")) {
    return "ACTUALIZACION";
  } 
  
  return "NO DEFINIDO";
}

export function procedimientoType(observations){
  if (observations.includes("CO001") || observations.includes("CO002")) {
    return "INCLUSION";
  }
  if (observations.includes("CO101") || observations.includes("CO102")) {
    return "ACTUALIZACION-VALOR";
  }
  if (observations.includes("CO201") || observations.includes("CO202")) {
    return "ACTUALIZACION-BENEFICIARIOS";
  }
  if (observations.includes("CO301") || observations.includes("CO302")) {
    return "ACTUALIZACION-DATOS";
  } 
  
  return "NO DEFINIDO";
}